(angular => {

  angular.module("App")

    .filter("typesActivity", [CompanyTypeFilter]);

  function CompanyTypeFilter() {

    const types = {
      "main": "Corporativa",
      "additional": "Complementar",
      "premium": "Premium",
      "meeting" : "Reunião"
    };

    function filter(type, event) {
      const eventTypes = {};

      if (event) {
        eventTypes.premium = event.name_activity_premium;
        eventTypes.marketing_activity = event.marketing_activity_name;
      }

      return eventTypes[type] || types[type] || type;
    }

    return filter;
  }

})(angular);
